import { ReleaseData, CollectionObject } from '@sworkit/api';
import { swApi } from './app';
import { saveWorkoutReleaseData } from './firestore-user';
export const baseReleaseData: ReleaseData = {
  previousSignInTimestamp: Date.now(),
  currentSignInTimestamp: Date.now(),
};

export const millisecondsToWaitBeforeExpiring = 3 * 24 * 60 * 60 * 1000;

export const hasCurrentSignInExpired = (timestampMillis: number) => {
  if (!timestampMillis || typeof timestampMillis !== 'number') return true;
  return Date.now() - millisecondsToWaitBeforeExpiring >= timestampMillis;
};

export const shouldShowNewBadge = (
  releaseData: ReleaseData,
  workoutOrCollectionReleaseTimestamp: number,
  earliestTimestampToConsiderAsNew = 0,
) => {
  const { currentSignInTimestamp, previousSignInTimestamp } = {
    ...baseReleaseData,
    ...releaseData,
  };

  if (
    !currentSignInTimestamp ||
    !previousSignInTimestamp ||
    !workoutOrCollectionReleaseTimestamp
  ) {
    return false;
  }

  return (
    !hasCurrentSignInExpired(currentSignInTimestamp) &&
    workoutOrCollectionReleaseTimestamp >= previousSignInTimestamp &&
    workoutOrCollectionReleaseTimestamp >= earliestTimestampToConsiderAsNew
  );
};

export function getReleaseBadges(collections: CollectionObject[]) {
  const timestampByCollectionSlug = {};
  if (collections) {
    collections.forEach((collection) => {
      timestampByCollectionSlug[collection.slug] =
        getLatestReleaseTimestamp(collection);
    });
  }
  return timestampByCollectionSlug;
}

export function getLatestReleaseTimestamp(collection: CollectionObject) {
  const { collection: workouts } = collection;
  if (!workouts) return 0;
  return workouts
    .filter((workout) => workout)
    .reduce(
      (min, workout) =>
        workout.releaseTimestamp > min ? workout.releaseTimestamp : min,
      0,
    );
}

export function updateUserReleaseData(
  userReleaseData: ReleaseData,
  latestReleaseTimestamp: number = swApi.currentReleaseTimestamp,
) {
  const { currentSignInTimestamp } = userReleaseData || {};
  if (
    hasCurrentSignInExpired(currentSignInTimestamp) ||
    latestReleaseTimestamp > currentSignInTimestamp
  ) {
    const newReleaseData: ReleaseData = {
      currentSignInTimestamp: Date.now(),
      previousSignInTimestamp: currentSignInTimestamp || Date.now(),
    };
    return saveWorkoutReleaseData(newReleaseData);
  }
  return Promise.resolve();
}
